import React from 'react'
import { Marker } from 'react-mapbox-gl'
import { connect } from 'react-redux'
import { array, bool } from 'prop-types'
import StreetViewImage from '../../../assets/img/watchPos.png'

const WatchPos = ({ watchLocation, center }) =>
  watchLocation ? (
    <Marker coordinates={center} anchor="bottom">
      <img
        src={StreetViewImage}
        alt="StreetView Icon"
        className="activeMarker"
      />
    </Marker>
  ) : null

WatchPos.propTypes = {
  center: array.isRequired,
  watchLocation: bool.isRequired,
}

const mapStateToProps = ({ map, spi }) => ({
  center: map.cache.center,
  watchLocation: spi.watchLocation,
})

export default connect(mapStateToProps)(WatchPos)



// WEBPACK FOOTER //
// ./src/components/Map/Markers/WatchPos.jsx